import { render } from "./MessageView.vue?vue&type=template&id=03bd9fd0&scoped=true"
import script from "./MessageView.vue?vue&type=script&lang=js"
export * from "./MessageView.vue?vue&type=script&lang=js"

import "./MessageView.vue?vue&type=style&index=0&id=03bd9fd0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bd9fd0"]])

export default __exports__